import React, { useState, useEffect } from 'react';
import ProjectCard from '../products/modeling/ProjectCard';
import { projectsData } from '../../data/projectsData';

const ProjectsPage = () => {

  return (
    <div className="container mx-auto px-4 py-8 mt-12">
      <h1 className="text-3xl Pretendard-Bold text-[#414042] mb-4">프로젝트</h1>
      <p className="text-lg text-gray-600 mb-8">크리에이터 유닛 스토어와 함께한 프로젝트를 소개합니다.</p>

      {/* 나머지 프로젝트 그리드 */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {projectsData.map((project, index) => (
         <ProjectCard key={index} {...project} />
        ))}
      </div>
    </div>
  );
};

export default ProjectsPage; 